"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.isClickableElement = exports.uploadBlob = void 0;
__exportStar(require("./scroll"), exports);
__exportStar(require("./unloadLock"), exports);
const uploadBlob = (file, url, onProgress, signal) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    if (signal) {
        signal.addEventListener('abort', () => {
            xhr.abort();
            reject(new DOMException('The user aborted a request.', 'AbortError'));
        });
    }
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.addEventListener('load', ((_, ev) => {
        if (onProgress && ev) {
            onProgress(ev);
        }
        const responseData = parseResponse(xhr);
        resolve({ status: xhr.status, responseData });
    }));
    xhr.addEventListener('error', reject);
    if (onProgress) {
        xhr.upload.addEventListener('progress', onProgress);
    }
    xhr.upload.addEventListener('error', reject);
    xhr.upload.ontimeout = reject;
    xhr.send(file);
});
exports.uploadBlob = uploadBlob;
function parseResponse(xhr) {
    try {
        return JSON.parse(xhr.responseText);
    }
    catch (_a) {
        return xhr.responseText;
    }
}
const isClickableElement = (event) => {
    if (event.target instanceof Node) {
        const path = event === null || event === void 0 ? void 0 : event.composedPath();
        return path.some((element) => {
            if (element instanceof HTMLElement) {
                const isSpecificNode = ['BUTTON', 'A'].includes(element.nodeName);
                const isSpecificRole = element.role === 'button';
                const isSpecificDataType = element.dataset.role === 'dropdown';
                return isSpecificNode || isSpecificRole || isSpecificDataType;
            }
            return false;
        });
    }
    return false;
};
exports.isClickableElement = isClickableElement;
function downloadFile(file, name = '') {
    const anchor = document.createElement('a');
    const isBlob = file instanceof Blob;
    const url = isBlob ? URL.createObjectURL(file) : file;
    anchor.href = url;
    anchor.style.display = 'none';
    anchor.download = name;
    document.body.append(anchor);
    anchor.click();
    if (isBlob) {
        URL.revokeObjectURL(url);
    }
    anchor.remove();
}
exports.downloadFile = downloadFile;
